var map = {
	"./jun-loading/index.js": "51UB"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "pOPK";


//////////////////
// WEBPACK FOOTER
// ./src/components/base ^\.\/[\w-_]+\/index\.(js|vue)$
// module id = pOPK
// module chunks = 98